// import React, {Suspense} from 'react';
// import ReactDOM from 'react-dom/client';
// import './assets/scss/style.scss';
// import reportWebVitals from './reportWebVitals';
// const App = React.lazy(() => import('./App'));
// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//     <Suspense fallback={""}>
//         <App variant="chatbot" />
//     </Suspense>
// );
// reportWebVitals();


// for widget build
import "regenerator-runtime/runtime";
import React, {Suspense} from 'react';
import ReactDOM from 'react-dom';
import './assets/scss/style.scss';
const App = React.lazy(() => import('./App'));

// Find all widget divs
const WidgetDivs = document.querySelectorAll('.chat_talkk_widget')

// Inject our React App into each
WidgetDivs.forEach(Div => {
  ReactDOM.render(
    <React.StrictMode>
        <Suspense fallback={""}>
            <App domElement={Div} />
        </Suspense>
    </React.StrictMode>,
    Div
  );
})
